export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/v2/landing-pages/_next/static/media/QuickLinks.db19e1dd.svg","height":21,"width":20};